import $ from 'jquery';
import 'slick-carousel';
import utils from './../utils.js';
import { push } from './../store/history.js';
import * as allgames from './allgames.js';
import { store } from './store.js';
import gameTemplate from './../templates/games.handlebars';
import { handleDoubleEvents } from './../utils/custom-events.js';
import { checkSessionAndLoadGame, doubleClickOnGameItem, processSupportNavEvents } from './casino.js';
import { handleLoveEvents } from './mygames.js';

const $bundleContainer = $('.games-by-bundle-container');
const $headerWrapperForBundles = $bundleContainer.find('.header-wrapper');
const $pageHeadForBundles = $bundleContainer.find('.page-head');
const $bundleImage = $bundleContainer.find('#bundle-page-image');
const $exploreContainer = $('#section1');
const $bundleCarousels = $exploreContainer.find('.bundle-carousel');
const $bundleCells = $exploreContainer.find('.bundle-cell');
const eventType = 'click';
const prevScrollPos = [0, 0];

// This adding an effect to fade away the bundle image / Martin
$(window).scroll(() => {
	$headerWrapperForBundles.find('img').css('opacity', 1 - ($(window).scrollTop() / 200));
});

// debounce the scroll event to put a background on the header and avoid overlapping
const changeHeaderWhenScroll = utils.debounce(() => {
	if ($bundleContainer.scrollTop() > 0) {
		$headerWrapperForBundles.find('.header__title').addClass('header__title--hide');
	} else {
		$headerWrapperForBundles.find('.header__title').removeClass('header__title--hide');
	}
	if ($bundleContainer.scrollTop() > 25) {
		$pageHeadForBundles.addClass('page-head--opac');
		$pageHeadForBundles.find('.page-head__title').addClass('page-head--opac');
	} else {
		$pageHeadForBundles.removeClass('page-head--opac');
		$pageHeadForBundles.find('.page-head__title').removeClass('page-head--opac');
	}
}, 100);

$bundleContainer.scroll(changeHeaderWhenScroll);

function togglePusherScrollability() {
	document.querySelector('.pusher').classList.toggle('u-lock-parent-view');

}

$bundleContainer.find('.icon-close').on(eventType, () => {
	push('/casino/explore');
});

function closePage() {
	$bundleContainer.removeClass('games-by-bundle-container--is-open u-transform-none');
	togglePusherScrollability();
	window.scrollTo(prevScrollPos[0], prevScrollPos[1]);
}

function moveBundles() {
	// we want to show a different bundle every time a bundle carousel is shown
	$bundleCarousels.each((i) => {
		let carousel = $bundleCarousels.eq(i).find('.gallery');
		carousel.hasClass('slick-initialized') && carousel.slick('slickGoTo', i);
	});
}

function bindClickEvents() {
	$bundleContainer.off('click.openGame')
		.on('click.openGame', (e) => {
		const classList = e.target.classList;
		if (classList.contains('game-item__img') || (classList.contains('main-title') && target.parentElement.classList.contains('game-item__title-wrapper'))) {
			e.preventDefault();
			const $game = e.target.closest('.game-item');
			handleDoubleEvents(e, $game, checkSessionAndLoadGame, doubleClickOnGameItem);
		}
	});

	$bundleContainer.off('click.supportNav')
		.on('click.supportNav', (e) => {
			processSupportNavEvents(e);
		});

	$bundleContainer.off('click.love')
		.on('click.love', handleLoveEvents);

}

// set up click handler for bundles module
function open(name) {

	//save the previous scroll position
	prevScrollPos[0] = window.scrollX;
	prevScrollPos[1] = window.scrollY;

	let bundleCell = null;
	$bundleCells.each(function () {
		if ($(this).find('.bundle-cell__image').data('game') === name) {
			bundleCell = this;
		}
	});

	if (!bundleCell) {
		return;
	}


	// add the class to make the bundle info appear
	const $bundlePageContainer = $('.games-by-bundle-container');
	$bundlePageContainer.addClass('games-by-bundle-container--is-open');
	togglePusherScrollability();
	setTimeout(() => {
		$bundleContainer.addClass('u-transform-none');
	}, 300);

	const bundleName = $(bundleCell).find('.bundle-carousel__main-title').text().trim();
	const bundleSubTitle = $(bundleCell).find('.bundle-carousel__sub-title').text().trim();


	// scroll to top to make sure we show bundle title
	window.scrollTo(0, 0);

	// add the title and sub-title to the bundle info
	$bundlePageContainer.find('#bundle-page-title').text(bundleName);
	$bundlePageContainer.find('#bundle-page-sub-title').text(bundleSubTitle);

	const $replacingImage = $(bundleCell).find('img');

	$bundleImage.attr({
		'data-srcset': $replacingImage.attr('data-srcset'),
		'data-src': $replacingImage.attr('data-src')
	});
	$bundleImage.addClass('lazyload');

// add the games from all games to gamebundles game grid
	let gamesToBeDisplayed = $(bundleCell).attr('data-games').split(',');

	async function displayBundleGames () {
		await allgames.getAllGames();

		gamesToBeDisplayed = gamesToBeDisplayed.map((v) => { return parseInt(v.match(/\d+/g)[0]); });

		const elementsToAdd = {
			'gameData': {
				'all': []
			}
		};

		elementsToAdd.gameData.all = store.get().gameResource.gameData.all.filter((v) => {
			return gamesToBeDisplayed.indexOf(v.gameSiteId) !== -1;
		});

		$bundlePageContainer.find('#bundle-page-grid').html(gameTemplate(elementsToAdd));
	}
	$bundlePageContainer.find('.game-grid').empty();
	displayBundleGames();
	bindClickEvents();
}

export default {
	open,
	moveBundles,
	closePage
};




// WEBPACK FOOTER //
// ./mobile-core/src/casino/bundles.js